/* ============
 * Account Transformer
 * ============
 *
 * The transformer for the account
 */

import Transformer from './transformer';

export default class AccountTransformer extends Transformer {
  /**
   * Method used to transform a fetched account
   *
   * @param account The fetched account
   *
   * @returns {Object} The transformed account
   */
  static fetch(account) {
    return {
      id: account.id,
      userId: account.user_id,
      password: account.password,
      passwordConfirmation: account.password_confirmation,
      firstName: account.first_name,
      lastName: account.last_name,
      email: account.email,
      phoneNumber: account.phone_number,
      mobileNumber: account.mobile_number,
      careOf: account.care_of,
      streetName: account.street_name,
      secondStreetName: account.second_street_name,
      postalCode: account.postal_code,
      cityName: account.city_name,
      countryId: account.country_id,
      userMobileNumber: account.user_mobile_number,
      sms2faEnabled: account.sms_2fa_enabled,
      google2faEnabled: account.google_2fa_enabled,
      userEmail: account.user_email,
      language: account.language,
      userFirstName: account.user_first_name,
      userLastName: account.user_last_name,
      businessRegistrationNumber: account.business_registration_number,
      isImpersonated: account.is_impersonated,
      debugMode: account.debug_mode,
      isVatRegistered: account.is_vat_registered,
      isRegisteredBusinessEnterprise: account.is_registered_business_enterprise,
      bankAccount: account.bank_account,
      smallScaleManufacturer: account.is_small_scale_manufacturer,
      verified: account.verified,
      subscribed: account.subscribed,
      organizationType: account.organization_type,
      organizationTypeId: account.organization_type_id,
      organizationName: account.organization_name,
      organizationDescription: account.organization_description,
      organizationProfilePicture: account.organization_profile_picture ? { url: account.organization_profile_picture } : undefined,
      plan: account.plan,
      modules: account.modules,
      organizations: account.subscribed_to_organizations,
      organizationMembers: account.organization_members,
      productDisplay: account.product_display,
      productGrouping: account.product_grouping,
      gs1number: account.gs1number,
      isPartner: account.is_partner,
      isInternational: account.is_international,
      bankName: account.bank_name,
      swift: account.swift,
      iban: account.iban,
      allowProducerBatches: account.allow_producer_batches,
      stockReportBeta: account.stock_report_beta,
      hasPartner: account.has_partner,
    };
  }

  /**
   * Method used to transform a send account
   *
   * @param account The account to be send
   *
   * @returns {Object} The transformed account
   */
  /* eslint max-len: ["error", 150] */
  static send(account) {
    return {
      email: account.email,
      password: account.password,
      password_confirmation: account.passwordConfirmation,
      first_name: account.firstName,
      last_name: account.lastName,
      phone_number: account.phoneNumber ? account.phoneNumber : '',
      mobile_number: account.mobileNumber ? account.mobileNumber : '',
      care_of: account.careOf,
      street_name: account.streetName,
      second_street_name: account.secondStreetName ? account.secondStreetName : '',
      postal_code: account.postalCode,
      city_name: account.cityName,
      country_id: account.countryId,
      user_email: account.userEmail,
      language: account.language,
      user_first_name: account.userFirstName,
      user_last_name: account.userLastName,
      business_registration_number: account.businessRegistrationNumber,
      is_vat_registered: (account.isVatRegistered === true || account.isVatRegistered === 1) ? 1 : 0,
      is_registered_business_enterprise: (account.isRegisteredBusinessEnterprise === true || account.isRegisteredBusinessEnterprise === 1) ? 1 : 0,
      bank_account: account.bankAccount,
      is_small_scale_manufacturer: account.smallScaleManufacturer === true || account.smallScaleManufacturer === 1 ? 1 : 0,
      organization_type_id: account.organizationTypeId,
      organization_name: account.organizationName ? account.organizationName : '',
      organization_description: account.organizationDescription ? account.organizationDescription : '',
      organization_profile_picture: (account.organizationProfilePicture && account.organizationProfilePicture.file) ?
      account.organizationProfilePicture.file : '',
      gs1number: account.gs1number,
      is_international: (account.isInternational === true || account.isInternational === 1) ? 1 : 0,
      bank_name: account.bankName,
      swift: account.swift,
      iban: account.iban,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/account.js